import { EveRoutes } from '@ver-uds/e-verify';
import { AuthServiceConfig, AuthServiceLifecycleHooks } from '@vis-auth/vis-auth';
import { User } from '@vis-auth/vis-user-client';
import AuthScopes from '../constants/AuthScopes';
import { SESSION_WARNING_TIMER, SESSION_TIMEOUT_TIMER } from '../context/Security/SessionTimers';

// Used for SecurityProvider and VisAuthService initialization
const getAuthConfig: (
  AUTH_CLIENTID: string,
  LOGIN_DOT_GOV_AUTH_CLIENTID: string,
  LOGIN_DOT_GOV_URL: string,
  useLoginDotGovConfig?: boolean,
) => AuthServiceConfig = (
  AUTH_CLIENTID: string,
  LOGIN_DOT_GOV_AUTH_CLIENTID: string,
  LOGIN_DOT_GOV_URL: string,
  useLoginDotGovConfig: boolean | undefined,
) => {
  const AUTH_URL = '/api/identity/v1';

  const loginDotGovEnabled =
    LOGIN_DOT_GOV_AUTH_CLIENTID && (useLoginDotGovConfig || window.location.pathname.includes('loginDotGov'));
  const redirectUri = window.location.origin + EveRoutes.LOGIN + (loginDotGovEnabled ? '/loginDotGov' : '');

  const lifecycleHooks: AuthServiceLifecycleHooks = {
    onHandleAuthentication: async (path: string) => {
      return Promise.all([window.history.pushState({}, '', redirectUri)]).then(() => Promise.resolve());
    },
  };

  return {
    issuer: AUTH_URL,
    clientId: loginDotGovEnabled ? LOGIN_DOT_GOV_AUTH_CLIENTID : AUTH_CLIENTID,
    redirectUri,
    loginDotGovUrl: LOGIN_DOT_GOV_URL,
    tokenStorage: 'cookie',
    errorPath: '/error',
    session: {
      // this warning and timeout state is currently not being used but instead handled by SessionHandler component,
      // including here because they are required properties in order to set disableNavigationRefresh
      warning: SESSION_WARNING_TIMER,
      timeout: SESSION_TIMEOUT_TIMER,
      disableNavigationRefresh: true,
    },
    scope: loginDotGovEnabled ? AuthScopes.LOGIN_DOT_GOV : AuthScopes.VIS,
    hooks: lifecycleHooks,
  };
};

export default getAuthConfig;
